import { type Provider, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RuntimeConfigService } from '../config/runtime-config';
import { AuthApi, HttpAuthApi } from './auth-api';
import { InMemoryAuthApi } from './in-memory-auth-api';

/**
 * Chooses the `AuthApi` implementation from `mockApi` in the runtime config. The factory
 * runs when something first injects `AuthApi`, which is after the config initializer.
 *
 * A production build refuses the mock outright. A config file copied from a developer's
 * machine must not turn sign-in into "any password works" in a live deployment.
 */
export function provideAuthApi(): Provider {
  return {
    provide: AuthApi,
    useFactory: (): AuthApi => {
      const { mockApi } = inject(RuntimeConfigService).config();
      if (!mockApi) return new HttpAuthApi();
      if (environment.production) {
        throw new Error('mockApi is on in config.json, which a production build does not allow.');
      }
      return new InMemoryAuthApi();
    },
  };
}
